import React, { useEffect, useState } from "react";
import "./RegrasView.css";

const API = "https://gerencial.vionia.com.br/api";

export default function RegrasView() {
  const [regras, setRegras] = useState([]);
  const [descricao, setDescricao] = useState("");
  const [condicao, setCondicao] = useState("");
  const [editandoId, setEditandoId] = useState(null);
  const [novoProdutoId, setNovoProdutoId] = useState("");

  useEffect(() => {
    carregarRegras();
  }, []);

  const carregarRegras = async () => {
    const res = await fetch(`${API}/regras`);
    const data = await res.json();
    setRegras(data);
  };

  const salvarRegra = async () => {
    const body = {
      descricao,
      condicao,
      ativa: true,
      produto_id: novoProdutoId || null,
    };
    const metodo = editandoId ? "PUT" : "POST";
    const url = editandoId ? `${API}/regras/${editandoId}` : `${API}/regras`;

    await fetch(url, {
      method: metodo,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    setDescricao("");
    setCondicao("");
    setNovoProdutoId("");
    setEditandoId(null);
    carregarRegras();
  };

  const editar = (regra) => {
    setDescricao(regra.descricao);
    setCondicao(regra.condicao);
    setNovoProdutoId(regra.produto_id || "");
    setEditandoId(regra.id);
  };

  const alternarAtiva = async (id) => {
    await fetch(`${API}/regras/${id}/toggle`, { method: "PUT" });
    carregarRegras();
  };

  return (
    <div className="regras-container">
      <h2>Cadastro de Regras</h2>

      <div className="regra-form">
        <input
          placeholder="Descrição"
          value={descricao}
          onChange={(e) => setDescricao(e.target.value)}
        />
        <input
          placeholder="Condição (ex: idade > 60)"
          value={condicao}
          onChange={(e) => setCondicao(e.target.value)}
        />
        <input
          type="text"
          placeholder="Produto (opcional)"
          value={novoProdutoId}
          onChange={(e) => setNovoProdutoId(e.target.value)}
        />
        <button onClick={salvarRegra}>
          {editandoId ? "Atualizar" : "Adicionar"}
        </button>
      </div>

      <table className="regra-tabela">
        <thead>
          <tr>
            <th>ID</th>
            <th>Descrição</th>
            <th>Condição</th>
            <th>Produto</th>
            <th>Status</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {regras.map((r) => (
            <tr key={r.id}>
              <td>{r.id}</td>
              <td>{r.descricao}</td>
              <td><code>{r.condicao}</code></td>
              <td>{r.produto_id || "—"}</td>
              <td>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={r.ativa}
                    onChange={() => alternarAtiva(r.id)}
                  />
                  <span className="slider round"></span>
                </label>
              </td>
              <td>
                <button onClick={() => editar(r)}>Editar</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
